'use client';

import type { AnchorHTMLAttributes, MouseEvent, ReactNode } from 'react';
import { useLogin } from './LoginContext';

type Props = Omit<AnchorHTMLAttributes<HTMLAnchorElement>, 'href' | 'onClick'> & {
  returnTo?: string;
  children: ReactNode;
};

/** Opens the nav sign-in drawer; falls back to /login/ when JS is unavailable. */
export function LoginLink({ returnTo = '/', children, className, ...rest }: Props) {
  const { openLogin } = useLogin();
  const href = `/login/?returnTo=${encodeURIComponent(returnTo.startsWith('/') ? returnTo : '/')}`;

  function onClick(e: MouseEvent<HTMLAnchorElement>) {
    e.preventDefault();
    openLogin(returnTo);
  }

  return (
    <a href={href} className={className} onClick={onClick} {...rest}>
      {children}
    </a>
  );
}
